import type { FaireProductEntity } from "../../entity_types/product";

export const p_w23khcg3rf: FaireProductEntity = {
  token: "p_w23khcg3rf",
  type: "product",
  name: "Bite Sized Mini Sticky Tabs: Grocery Trip",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/791c75b5e2e2f94a3aedeeb5663a070327a105aad69f5c8a18d70ad9c5767c7c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37333ca6eaef80550ddfa8aaa416071dfbc32e346e937a6611486e3ac7ff5430.jpeg",
    "https://cdn.faire.com/fastly/94c2f408e71a56ebb85ce81b2144827123405aac49810d5e24e63ad38d469490.jpeg",
    "https://cdn.faire.com/fastly/9376ca04ca835dad0bbdae00f0af9d480158e608c29a66cd06983089af673144.jpeg"
  ],
  priceDollars: 9,
  description: "Our bite sized sticky index tabs come in a set of four delicious designs. Perfect for bookmarking, note-taking and organizing your planners, cookbooks, and journals. A stationery lover (and foodie's) dream!\n\nFish, Olive, Tomato and Ravioli design on each tab.\n\nGood to know\n- Set of 4 Sticky Tabs (120 sheets)\n- Stick and restick anywhere!\n- Each tab is around 2\"x2\" \n- Made with recycled paper.\n\nPackaging: \n- Uncoated paper envelope with window.\n- Size: 4.5x5.5\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:09.133Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
